module.exports = __webpack_public_path__ + "img/google-play.49a2d7ef.png";